import * as React from 'react'
import { Modal, ModalProps } from 'components/common'

export interface DiscountCancelModalProps extends Omit<ModalProps, 'onOk'> {
  onOk: () => void
}

export const DiscountCancelModal = ({
  onOk,
  ...rest
}: DiscountCancelModalProps) => (
  <Modal
    title={<div className="text-3xl font-bold">ディスカウントの削除</div>}
    cancelText="キャンセル"
    onOk={onOk}
    okText="削除"
    okButtonProps={{ type: 'primary' }}
    {...rest}
  >
    <div className="mb-2">ディスカウントを削除してよろしいでしょうか？</div>
    <div>※この操作は取り消すことができません。</div>
  </Modal>
)
